const getters = {
  menuData: state => state.menu.menuList,
  menuIndex: state => state.menu.code,
  menuName: state => state.menu.menuName,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js